export class UserPermissions {
	groupName: string;
	permissions: Array<Permission>;
}
export class Permission {
	resourceName: string;
	enabled: boolean;
}
